module.exports = __webpack_public_path__ + "img/logo.60653020.png";